<template>
    <div class="footer-page">
        <a class="notice-of-app-patient mr-30" href="javascript:void(0);"
          @click.stop="showNotices(USER_TYPE_PATIENT)"
            v-if="this.$auth.user().type === USER_TYPE_PATIENT"
            >お知らせ</a>
        <a class="notice-of-app-pharmacist mr-30" href="javascript:return void();"
          @click.stop="showNotices(USER_TYPE_PHARMACIST)"
            v-if="this.$auth.user().type === USER_TYPE_PHARMACIST"
            >お知らせ</a>
        <a class="terms-of-use mr-30" target="_blank" href="https://pocketmeeting.jp/rules.html">
            利用規約
        </a>
        <a class="privacy" target="_blank" href="https://pocketmeeting.jp/privacy.html">
            プライバシーポリシー
        </a>
        <div class="version mr-30">[ {{ version }} ]</div>
        <ShowModaler
            v-model="showModal"
            :iframeName="modalName"
            :iframeSrc="''" ref="footerModal"
             />
    </div>
</template>

<script>
import {USER_TYPE_PHARMACIST, USER_TYPE_PATIENT} from '@/const'
import ShowModaler from '@/components/ShowModaler'
import MasterDataApi from '@/api/master'
import {apiErrorDialog} from '@/helpers'
import packageJson from '../../../package.json'

export default {
  components: {ShowModaler},
  data () {
    return {
      USER_TYPE_PHARMACIST,
      USER_TYPE_PATIENT,
      showModal: false,
      version: packageJson.version,
      modalName: 'footer_iframe'
    }
  },
  methods: {
    async showNotices (type) {
      // Cross-Dmainでうまく表示できない問題で一旦コメントアウト
      // const res = await MasterDataApi.get()
      //   .catch((error) => apiErrorDialog(this, error))
      // if (!res) return
      // let url = res.data.data.notice_endpoint || '/static/notices/'
      let url = '/static/notices/'
      if (type === USER_TYPE_PHARMACIST) {
        url += '' // '?type=a';
      } else {
        url += '' // '?type=p';
      }
      this.setUrl(url, null)
    },
    async setUrl (url, token) {
      this.showModal = true
      document.querySelector('#' + this.modalName).src = url
    },
    closeModal () {
      this.showModal = false
      document.querySelector('#' + this.modalName).src = ''
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue